/**
 * Luxury Botanical Garden Store - Micro-interactions
 * Lightweight, non-blocking enhancements.
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Scroll-triggered animations */
  function initScrollAnimations() {
    const elements = document.querySelectorAll('[data-sg-animate]');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.dataset.sgDelay || '0', 10);
            setTimeout(function () {
              el.classList.add('sg-animate--visible');
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* Cart count bump animation */
  function initCartAnimation() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    new MutationObserver(function () {
      bubble.classList.remove('sg-cart-bump');
      void bubble.offsetWidth;
      bubble.classList.add('sg-cart-bump');
    }).observe(bubble, { childList: true, characterData: true, subtree: true });
  }

  /* Header shadow on scroll */
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 80) {
        header.classList.add('header-wrapper--scrolled');
      } else {
        header.classList.remove('header-wrapper--scrolled');
      }
    });
  }

  function init() {
    initScrollAnimations();
    initCartAnimation();
    initHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
